export default __webpack_public_path__ + "c6836bc74cf38f34e0ca5fc7295fb914.png";